// extracted by mini-css-extract-plugin
export default {"suspended":"w6Q6F4kqmii63lAOOjIo"};